import {FC, memo, RefObject, useMemo} from 'react';
import {IQuickMenuItem, QuickMenu, Svg, useModal, useScreenSize} from '@kcast-fe/ui-kit';
import {generatePath} from 'react-router';
import {Box} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {ROUTES} from 'core';

interface IProps {
  msgId: string;
  isFinal: boolean;
  containerRef: RefObject<HTMLDivElement | null>;
}

// Day separator pill. The caller decides where it appears (in-flow between
// messages, or the single stuck copy above the list).
const DotsMenuFC: FC<IProps> = ({containerRef, isFinal, msgId}) => {
  const {isLessThan768} = useScreenSize();
  const {t} = useT();
  const {openModal} = useModal();

  const menuItems: IQuickMenuItem<string>[] = useMemo(() => {
    return [
      {
        id: 'inspector',
        name: t('actions.contextInspector'),
        onClick: () => openModal(generatePath(ROUTES.Modal.MsgInspector, {msgId}))
      }
      /*{
        id: 'flag',
        name: t('actions.flagResponse'),
        onClick: () => {}
      },
      {
        id: 'regenerate',
        name: t('actions.regenerateAnswer'),
        onClick: () => {},
        isDanger: true
      }*/
    ];
  }, [t, openModal, msgId]);

  return (
    <Box pos={'absolute'} right={'-10px'} top={'-10px'} zIndex={1}>
      <Box
        opacity={isFinal && isLessThan768 ? 1 : 0}
        transition={'opacity var(--tr-150-ei)'}
        _groupHover={{opacity: isFinal ? 1 : 0}}
      >
        <QuickMenu
          hideActive
          items={menuItems}
          container={containerRef}
          trigger={
            <Box
              bg={'{colors.white}'}
              borderRadius={'full'}
              shadow={'{shadows.msg_1}'}
              color={'{colors.textSecondary}'}
              cursor={'pointer'}
            >
              <Svg name={'Dots'} size={'s32'} />
            </Box>
          }
        />
      </Box>
    </Box>
  );
};

export const DotsMenu = memo(DotsMenuFC);
